function setUpDialog(scope) {
  scope.querySelectorAll("dialog.dialog-open-modal").forEach(dialog => dialog.showModal());
  scope.querySelectorAll("dialog.dialog-open").forEach(dialog => dialog.show());
}

export {setUpDialog};
